import styles from "../../styles/customInput.module.scss";
import MagnifyingGlass from "../../public/assets/magnifiying-glass.svg";

export default function CustomInput({
  className,
  placeholder,
}: {
  className?: string;
  placeholder?: string;
}) {
  return (
    <div className={`${styles.main} ${className}`}>
      <MagnifyingGlass className={styles.icon}></MagnifyingGlass>
      <input className={`${styles.input}`} placeholder={placeholder}></input>
    </div>
  );
}
